import { Directive, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';

import {
  FindControlAdditionalSearchParametersDto,
  FindControlAdditionalSearchParametersType,
} from 'webcommon/shared';

import { FcFilterModalBaseComponent } from './fc-filter-modal-base.component';

export enum FcFilterConfigurationFieldType {
  Single,
  Multiple,
}

export interface FcFilterConfigurationSingleValueField {
  type: FcFilterConfigurationFieldType.Single;
  control: FormControl<string | null | undefined>;
}

export interface FcFilterConfigurationMultiValueField {
  type: FcFilterConfigurationFieldType.Multiple;
  control: FormControl<string[]>;
}

export type FcFilterConfigurationField = FcFilterConfigurationSingleValueField | FcFilterConfigurationMultiValueField;

@Directive()
export abstract class FcGenericFilterModalBaseComponent extends FcFilterModalBaseComponent implements OnInit {
  abstract form: FormGroup;

  public baseId = 'fc-filter';
  public disableClear = false;

  protected config = new Map<string, FcFilterConfigurationField>();

  protected constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();

    if (this.fcFilterModalContext.previousSearchParameters?.AdditionalSearchParameters?.length) {
      for (const additionalSearchParameter of this.fcFilterModalContext.previousSearchParameters.AdditionalSearchParameters) {
        const field = this.config.get(additionalSearchParameter.ColumnName);
        if (field) {
          const fieldType = field.type;
          switch (fieldType) {
            case FcFilterConfigurationFieldType.Multiple:
              field.control.value.push(additionalSearchParameter.Value);
              break;
            case FcFilterConfigurationFieldType.Single:
              field.control.setValue(additionalSearchParameter.Value);
              break;
            default:
              throw new Error(`Developer Exception: unknown field type: ${fieldType}`);
          }
        }
      }
    }
  }

  public tabChanged(tabChangeEvent: MatTabChangeEvent) {
    this.disableClear = tabChangeEvent.index !== 0;
  }

  public onClear() {
    for (const field of this.config.values()) {
      const fieldType = field.type;
      switch (fieldType) {
        case FcFilterConfigurationFieldType.Multiple:
          field.control.setValue([]);
          break;
        case FcFilterConfigurationFieldType.Single:
          field.control.setValue('');
          break;
        default:
          throw new Error(`Developer Exception: unknown field type: ${fieldType}`);
      }
    }
  }

  public save() {
    const userSearchParameters: FindControlAdditionalSearchParametersDto = {
      Type: FindControlAdditionalSearchParametersType.MultipleValues,
      AdditionalSearchParameters: [],
    };

    for (const [columnName, field] of this.config) {
      const fieldType = field.type;
      switch (fieldType) {
        case FcFilterConfigurationFieldType.Multiple:
          for (const value of field.control.value) {
            userSearchParameters.AdditionalSearchParameters.push({
              ColumnName: columnName,
              Value: value,
            });
          }
          break;
        case FcFilterConfigurationFieldType.Single:
          if (field.control.value) {
            userSearchParameters.AdditionalSearchParameters.push({
              ColumnName: columnName,
              Value: field.control.value,
            });
          }
          break;
        default:
          throw new Error(`Developer Exception: unknown field type: ${fieldType}`);
      }
    }

    this.onClose(userSearchParameters);
  }
}
